import * as angular from 'angular';
import {AgentStatusType} from "../types/agentStatus.type";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.agents')
  .factory('AgentsAPI', AgentsAPI);

const agentStatusTypes: typeof AgentStatusType = AgentStatusType;

function AgentsAPI(): BringozApi {

  return {
    base: `/agents`,
    infiniteScroll: {
      address: `/agents`,
      cmd: 'GET'
    },
    actions: {
      getOne: {
        address: '',
        cmd: 'GET',
        updateable: true
      },
      getAgentsPagination: {
        address: 'paginated',
        cmd: 'GET',
        updateable: false
      },
      assignAgents: {
        address: 'assignConfigurationProfile',
        cmd: 'POST',
        updateable: true
      },
      createOne: {
        address: '',
        cmd: 'PUT',
        updateable: true
      },
      updateOne: {
        address: '',
        cmd: 'POST',
        updateable: true
      },
      getEngagement: {
        address: 'engagement',
        cmd: 'GET',
        updateable: false
      },
      getRequirements: {
        address: 'requirements',
        cmd: 'GET',
        updateable: false
      },
      postRequirements: {
        address: 'requirements/{requirementId}',
        cmd: 'POST',
        updateable: false
      },
      getPreferences: {
        address: 'preferences',
        cmd: 'GET',
        updateable: false
      },
      setPreferences: {
        address: 'preferences',
        cmd: 'POST',
        updateable: false
      },
      getAgreements: {
        address: 'agreements',
        cmd: 'GET',
        updateable: false
      },
      exportPending: {
        address: 'actions/export/pending',
        cmd: 'GET',
        updateable: false
      },
      addDepots: {
        address: 'addDepots',
        cmd: 'POST',
        updateable: false
      },
      addBranches: {
        address: 'addBranches',
        cmd: 'POST',
        updateable: false
      },
      changeStatusTo_OnDuty: {
        address: 'actions/changeStatus/' + agentStatusTypes.OnDuty,
        cmd: 'POST',
        updateable: false,
      },
      changeStatusTo_OnDutyOnBreak: {
        address: 'actions/changeStatus/' + agentStatusTypes.OnDutyOnBreak,
        cmd: 'POST',
        updateable: false,
      },
      changeStatusTo_OffDuty: {
        address: 'actions/changeStatus/' + agentStatusTypes.OffDuty,
        cmd: 'POST',
        updateable: false,
      },
      sendNotification: {
        address: 'actions/sendNotification',
        cmd: 'POST',
        updateable: false,
      },
      recalc: {
        address: 'itinerary/recalc',
        cmd: 'GET',
        updateable: false
      },
      refresh: {
        address: 'itinerary/refresh',
        cmd: 'GET',
        updateable: false
      },
      getItinerary: {
        address: 'itinerary',
        cmd: 'GET',
        updateable: false
      },
      editItineraryLock: {
        address: 'itinerary/edit/lock',
        cmd: 'POST',
        updateable: false
      },
      editItineraryUnlock: {
        address: 'itinerary/edit/unlock',
        cmd: 'POST',
        updateable: false
      },
      editItinerary: {
        address: 'itinerary/edit',
        cmd: 'POST',
        updateable: false
      },
      editItinerarySettings: {
        address: 'itinerary/edit/settings',
        cmd: 'POST',
        updateable: false
      },
      editItineraryReset: {
        address: 'itinerary/edit/reset',
        cmd: 'POST',
        updateable: false
      },
      getTotals: {
        address: 'totals/statuses',
        cmd: 'GET',
        updateable: false
      },
      getTotalsAssigned: {
        address: 'totals',
        cmd: 'GET',
        updateable: false
      },
      getRatings: {
        address: 'ratings',
        cmd: 'GET',
        updateable: false
      },
      getCommissions: {
        address: 'commissions',
        cmd: 'GET',
        updateable: false
      },
      completedTasks: {
        address: 'tasks?onlyCompleted=false',
        cmd: 'GET',
        updateable: false
      },
      postPayment: {
        address: 'payments',
        cmd: 'POST'
      },
      getAgentsByBranch: {
        address: '',
        cmd: 'GET',
        updateable: false
      },
      deleteAgent: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: false
      },
      updateCarrier: {
        address: '{id}/updateCarrier',
        cmd: 'POST',
        updateable: false
      },
      updateAgentLocation: {
        address: 'location',
        cmd: 'POST',
        updateable: false
      },
      updatePassword: {
        address: 'password',
        cmd: 'POST',
        updateable: false
      },
      selectScheduleTemplate: {
        address: 'selectSchedule',
        cmd: 'POST',
        updateable: false
      },
      clearSchedule: {
        address: 'clearSchedule',
        cmd: 'POST',
        updateable: false
      },
      addPaymentTransaction: {
        address: 'wallet',
        cmd: 'POST',
        updateable: true
      },
      getPaymentTransactionsTotals: {
        address: 'wallet/totals',
        cmd: 'GET',
        updateable: true
      },
      getAgentBalance: {
        address: 'wallet/balance',
        cmd: 'GET',
        updateable: false
      },
      bulkPreferencesUpdate: {
        address: 'bulk',
        cmd: 'POST',
        updateable: false
      },
      updateAgentAssistants: {
        address: 'assistants',
        cmd: 'POST',
        updateable: false
      },
      exportAgents: {
        address: 'actions/export',
        updateable: false,
        cmd: 'POST'
      },
      getAgentAssistants: {
        address: 'assistants',
        cmd: 'GET',
        updateable: false
      },
      getDocuments: {
        address: 'document',
        cmd: 'GET',
        updateable: true
      },
      createDocument: {
        address: 'document',
        cmd: 'PUT',
        updateable: true
      },
      updateDocument: {
        address: 'document/{documentId}',
        cmd: 'POST',
        updateable: true
      },
      deleteDocument: {
        address: 'document/{documentId}',
        cmd: 'DELETE',
        updateable: true
      },
      getReminders: {
        address: 'reminder',
        cmd: 'GET',
        updateable: false
      },
      createReminder: {
        address: 'reminder',
        cmd: 'PUT',
        updateable: false
      },
      updateReminder: {
        address: 'reminder/{reminderId}',
        cmd: 'POST',
        updateable: false
      },
      deleteReminder: {
        address: 'reminder/{reminderId}',
        cmd: 'DELETE',
        updateable: false
      },
      passwordless: {
        address: '{id}/passwordless',
        cmd: 'POST',
        updateable: false
      },
      agentPerformance: {
        address: '{id}/performance',
        cmd: 'GET',
        updateable: false
      },
      updateAgentExternalId: {
        address: 'externalId',
        cmd: 'POST',
        updateable: false
      },
      addAgentsToTeam: {
        address: 'addTeams',
        cmd: 'POST',
      },
      removeAgentsFromTeam: {
        address: 'removeTeams',
        cmd: 'POST',
      },
      getAgentCrossSiteData: {
        address: 'agentCrossSiteData',
        cmd: 'POST',
      }
    }
  }
}


